import ButtonLink from 'sd-ui/dist/commonjs/components/ButtonLink/ButtonLink';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export default function ArticleActionButton({
  icon, label, onClick, id, hasHighlight,
}) {
  const style = classnames('text-xs u-margin-l-right call-to-action', { 'active-look-at-me': hasHighlight });
  return (
    <ButtonLink
      icon={icon}
      className={style}
      onClick={() => onClick(id)}
      id={id}
    >
      {label}
    </ButtonLink>
  );
}

ArticleActionButton.propTypes = {
  hasHighlight: PropTypes.bool.isRequired,
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
